/**
 * localStorage の読み書きヘルパー。
 *
 * 画面のフィルター状態は「OFFにしたものの配列」や真偽値で保存しており、
 * 未設定・壊れた値のときは既定値へ倒す扱いを各所で繰り返していたためまとめた。
 */

/**
 * localStorage から JSON を読む。未設定・パース失敗・falsy な値は fallback を返す。
 *
 * JSON.parse(null) は null を返すため、従来の
 * `JSON.parse(localStorage.getItem(key)) || fallback` と同じ結果になる。
 */
export const readStoredJson = <T>(key: string, fallback: T): T => {
  try {
    return (JSON.parse(String(localStorage.getItem(key))) as T) || fallback;
  } catch {
    return fallback;
  }
};
